<template>

    <section class="featured bottom-space">
        <div class="ink-grid">

            <h2 class="section-title text-center">Novos em destaque</h2>

            <div class="double-horizontal-space bottom-space">
                <div class="featured-slider">
                    <div class="slide" v-for="n in 4">
                        <VehicleCard newVehicle featured></VehicleCard>
                    </div>
                </div>
            </div>

             <div class="ink-flex push-center">
                <a href="/carros-usados" class="ink-button">Procurar carro novo</a>
            </div>


        </div>
    </section>

</template>

<script>
    import VehicleCard from '../shared/vehicle-card.vue'

    export default {

        components: {
            VehicleCard
        },

        mounted () {

            $( document ).ready(function() {

                $('.featured-slider').slick({
                    dots: false,
                    infinite: true,
                    autoplay: false,
                    autoplaySpeed: 5000,
                    speed: 300,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    responsive: [
                        {
                            breakpoint: 640,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                centerMode: true,
                            }
                        },
                        {
                            breakpoint: 480,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                centerMode: false,
                            }
                        },
                    ]
                });

            });
        }
    };
</script>
